import { Place } from './place';
import { UserInfo } from './user';

export type Photo = {
  uri: string;
  height: number;
  width: number;
  html_attributions?: string[];
};

export type Plan = {
  planId: string;
  userId: string;
  user: Pick<UserInfo, 'displayName' | 'photoUrl'>;
  location: Place;
  startDate: Date;
  endDate: Date;
  public: boolean;
  photos: Photo[];
  createdAt: Date;
  updatedAt: Date;
  description?: string;
  notes?: string;
  numLikes?: number;
  numComments?: number;
  groupIds?: string[];
  userIds?: string[];
  joinsRequested?: boolean;
};

export type PlanFormData = Pick<
  Plan,
  | 'location'
  | 'startDate'
  | 'endDate'
  | 'description'
  | 'notes'
  | 'photos'
  | 'joinsRequested'
  | 'public'
>;

export type Comment = {
  comment: string;
  userId: string;
  createdAt: Date;
  commentId: string;
};

export type Like = {
  createdAt: Date;
  userId: string;
};

export type DateRange = {
  startDate?: Date;
  endDate?: Date;
};
